import { keys } from '@core/Services/Analytics/keys'
import { trackEvent } from '@core/Services/Analytics/track'

export const trackAccountActivityTab = (data: object): void =>
  trackEvent(keys.accountActivityTabChange, { data })

export const trackRebet = (data: object): void => trackEvent(keys.rebet, { data })
